<button
  class="btn btn--navigation"
  matRipple
  (click)="navigateToFirstPage()"
  matTooltip="Primera página"
  [disabled]="isFirstPageDisabled"
>
  <qr-icon
    [name]="ARROW_FIRST_PAGE"
    [color]="!isFirstPageDisabled ? ICON_COLOR_GREY_700 : ICON_COLOR_GREY_300"
  ></qr-icon>
</button>

<button
  class="btn btn--navigation"
  matRipple
  (click)="navigatePreviousPage()"
  matTooltip="Página anterior"
  [disabled]="isPreviousPageDisabled"
>
  <qr-icon
    [name]="ARROW_LEFT"
    [color]="
      !isPreviousPageDisabled ? ICON_COLOR_GREY_700 : ICON_COLOR_GREY_300
    "
  ></qr-icon>
</button>

<!--  *ngFor="let item of pagesArray | slice : paginationStart : paginationEnd" -->
<button
  *ngFor="let item of pagesArray"
  class="btn btn--page subheading-01-semi-bold"
  matRipple
  [class.active]="active == item"
  (click)="select(item)"
>
  {{ item }}
</button>

<button
  class="btn btn--navigation"
  matRipple
  (click)="navigateNextPage()"
  matTooltip="Página siguiente"
  [disabled]="isNextPageDisabled"
>
  <qr-icon
    [name]="ARROW_RIGHT"
    [color]="!isNextPageDisabled ? ICON_COLOR_GREY_700 : ICON_COLOR_GREY_300"
  ></qr-icon>
</button>

<button
  class="btn btn--navigation"
  matRipple
  (click)="navigateToLastPage()"
  matTooltip="Última página"
  [disabled]="isLastPageDisabled"
>
  <qr-icon
    [name]="ARROW_LAST_PAGE"
    [color]="!isLastPageDisabled ? ICON_COLOR_GREY_700 : ICON_COLOR_GREY_300"
  ></qr-icon>
</button>
